/**
 * GTM "Günün Fırsatı" FAB — yalnızca anasayfa + PLP.
 * PDP (/urun/...) ve diğer app sayfalarında gizlenir.
 */

const DEAL_FAB_LIST_PREFIXES = [
  '/urunler',
  '/cicek',
  '/kampanya',
  '/bolge',
  '/kategori',
] as const;

/** Ürün / checkout / hesap vb. — deal FAB yok */
const DEAL_FAB_BLOCKED = [
  '/sepetim',
  '/sepet-uyelik',
  '/profilim',
  '/blog',
  '/giris-yap',
  '/kayit-ol',
  '/siparis-alindi',
  '/siparis-odeme-hatasi',
  '/mobil-menu',
  '/mobile-auth',
  '/mobile-route',
  '/uygulama',
  '/oner-kazan',
  '/hediye-202506',
  '/gelin-arabasi-susleme',
  '/video-mesaj',
  '/sifre-kurtarma',
  '/sifremi-unuttum',
  '/log-out',
  '/404',
  '/api',
] as const;

function normalizePath(pathname: string): string {
  const path = (pathname.split('?')[0] || '/').trim() || '/';
  if (path.length > 1 && path.endsWith('/')) return path.slice(0, -1);
  return path;
}

function pathMatches(path: string, route: string): boolean {
  return path === route || path.startsWith(`${route}/`);
}

export function shouldShowDealFab(pathname: string): boolean {
  const path = normalizePath(pathname);
  if (path === '/') return true;

  // PDP
  if (path === '/urun' || path.startsWith('/urun/')) return false;
  // Checkout: /satin-al, /satin-al-alici-bilgileri, ...
  if (path === '/satin-al' || path.startsWith('/satin-al-') || path.startsWith('/satin-al/')) {
    return false;
  }
  for (const route of DEAL_FAB_BLOCKED) {
    if (pathMatches(path, route)) return false;
  }

  // Bilinen list route'lar
  for (const route of DEAL_FAB_LIST_PREFIXES) {
    if (pathMatches(path, route)) return true;
  }

  // [...slug] kategori / şehir / özel gün PLP (pretty URL)
  return true;
}
